import { RowStates } from '@/enums/system'
import { ColDef, GridOptions, EditableCallbackParams, GridApi, Column } from 'ag-grid-enterprise'

export const TABLE_FIELD_PERFIX = '$__'

export const tableFields = {
  id: `${TABLE_FIELD_PERFIX}id` as const,
  isValid: `${TABLE_FIELD_PERFIX}isValid` as const,
  invalidCells: `${TABLE_FIELD_PERFIX}invalidCells` as const,
  isLocked: `${TABLE_FIELD_PERFIX}isLocked` as const,
  rowType: `${TABLE_FIELD_PERFIX}rowType` as const
}


export type TTargetRowIndex = number | 'start' | 'end' | 'active'

export interface TDefaultFields {
  rowState: RowStates
  displayOrder: number
  [tableFields.id]: string
  [tableFields.isValid]: boolean
  [tableFields.invalidCells]: string[]
  [tableFields.isLocked]: boolean
  [tableFields.rowType]: 'aggregate' | 'row'
}
export interface IExtendedColDef<TData = any, TValue = any> extends ColDef<TData, TValue> {
  isEditable?: ((params: EditableCallbackParams<TData, TValue>) => boolean) | boolean
  entering?: ((row: TData) => boolean) | boolean
  leaving?: ((row: TData, col: Column) => boolean) | boolean
  generateOptions?: any
  validators?: IValidator[]
  columnId?: string
  aggregateFunction?: 'count' | 'sum' | 'min' | 'max' | 'avg' | IAggregateFunc<TData>
}

export interface IExtendedGridOptions<T = any> extends Omit<GridOptions<T>, 'columnDefs'> {
  gridId: string
  prepareNewRow?: (prevRow?: T) => T
  prepareDeleteRow?: (row: T) => boolean
  columnDefs?: IExtendedColDef[]
  canAddRow?: boolean
  addRowOnMount?: boolean
  rowIsLocked?: (rowData: T) => boolean
  isEditable?: boolean
  onCopyRow?: (row: T) => T
  prepareDataOnMount?: boolean
  enableAggregation?: boolean
}

export interface IExtendedGridApi<T = any> extends GridApi<T> {
  validateRowData?: (row: T, apply?: boolean, oldData?: T) => { row: T, isValid: boolean }
  addNewRow?: (targetIndex?: TTargetRowIndex, focus?: boolean, data?: T) => void
  tryDeleteLastEmptyRow?: () => boolean
}


export interface IValidator {
  error: (name: string, obj?: any) => string
  test: (val: any, obj?: any) => boolean
}

export interface IAggregateFunc<T = any> {
  (values: (T | null)[]): any
}

export type TObjectWithFieldOf<T, F = any> = { [key in keyof T]?: F }

export interface IActionDefinition<T = any> {
  name: string
  shortcut: IShortcutDefinition
  handler: (row: T | undefined, index: number | null | undefined, data: T[], col: Column | undefined | null, api: GridApi) => any
}

export interface IShortcutDefinition {
  altKey: boolean
  ctrlKey: boolean
  shiftKey: boolean
  keyCode: number
}